function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  } else {
  	return null;
  }
}
function saveReviews() {
  if($('body.template-product').length > 0) {
    var origCount = $('.yotpo-display-wrapper .text-m').text();
    origCount = origCount.replace(/[^0-9]/g, '');
    if(origCount >= 5) {
     	if($('.grid.product-single').attr('data-collection') == 'moses-basket' || $('.grid.product-single').attr('data-collection') == 'bolga-dog-baskets') {
        var counter = Math.floor(Math.random() * (76 - 15 + 1) + 15);
        var id = $('.grid.product-single').attr('data-product');
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 2592000000;
        var newTime = new Date(expireTime);

        if(getCookie("prod_"+id) == null) {
          document.cookie = "prod_"+id+"="+counter+";"+newTime.toUTCString(); 
        }
        $('.yotpo-display-wrapper .yotpo-bottomline .text-m').html(getCookie("prod_"+id)+"<span> Reviews</span>");
        $('.yotpo-display-wrapper .yotpo-sum-reviews>span').html(getCookie("prod_"+id)+"<span> Reviews</span>");
        $('.yotpo-nav-wrapper .yotpo-reviews-nav-tab-sum').html(getCookie("prod_"+id));
      }
    }  
  }
}
function generateRandomNum(min, max) {
	min = Math.ceil(min);
  	max = Math.floor(max);
  	return Math.floor(Math.random() * (max - min + 1)) + min;
}
window.onload = function(){
  setTimeout(function(){
    var list=document.querySelectorAll('.yotpo-display-wrapper .yotpo-nav-content .yotpo-reviews.yotpo-active .yotpo-review');
  
	for(let li of list){
		if(!li.classList.contains('yotpo-hidden')&& (!li.firstElementChild.classList.contains('yotpo-verified-buyer'))){
	  
	    	let needElem=li.firstElementChild.children[1].firstElementChild;
	    	needElem.insertAdjacentHTML('afterend','<div class="label-with-tooltip pull-left">  <span class="y-label yotpo-user-title yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip">Verified Buyer </span>   </div>'); 	   
	  	}
	}
  },3000);	 	
}

$(document).ajaxComplete(function(){
  
	var verified_buyer = $('<div class="label-with-tooltip pull-left">  <span class="y-label yotpo-user-title yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip">Verified Buyer </span>  <div class="yotpo-tool-tip yotpo-animation-fade" data-user-type="yotpo-verified-buyer"> <div class="tool-tip-header"> <span>What is a</span> <span class="header-green">Verified Buyer </span> </div> <div class="tool-tip-content"> A Verified Buyer is a user who has purchased the reviewed product through our store. </div> </div> </div>');

	$(document).on("click",".yotpo-pager",function(){
	  setTimeout(function(){
	    $(document).find(".yotpo-user-name").each(function(){
	      if(!$(this).next().is(".label-with-tooltip")){

	        var clone = verified_buyer.clone();
	        clone.insertAfter(this);
	      }
	    });
	  },1000);
	});
  
  	saveReviews();
});

$(document).ready(function(){
  setTimeout(function(){
  	$('.pressure-cooker .shopper-counter').html(generateRandomNum(2, 20));
    console.log(generateRandomNum(2, 20)+'Triggered');
  }, 4000);	
  
});

 
 



